/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { EnrollmentAppStore } from "../redux/enrollment-store/store";
import { connect } from "react-redux";
import { Environment } from "../utilities/environment";
import { BaseContainer } from "./base-container";
import { OfferingPageProperties, OfferingPage } from "../pages/offering-page";

function mapStateToProps(store: EnrollmentAppStore): OfferingPageProperties {
    return {
        fetchedData:
            store.dataFetchingStatus.bankAndTax &&
            store.dataFetchingStatus.enrollment &&
            store.dataFetchingStatus.metadata &&
            (!Environment.isModern() || true),
        error:
            (store.dataFetchingStatus.enrollment && store.errorStatus.enrollment) ||
            (store.dataFetchingStatus.bankAndTax && store.errorStatus.bankAndTax) ||
            (store.dataFetchingStatus.metadata && store.errorStatus.metadata) || 
            (!Environment.isModern() || true),
        enrollments: BaseContainer.getEnrollmentDetails(store)
    };
}

export const OfferingPageContainer = connect(mapStateToProps)(OfferingPage);
